import { useAuth } from "../../../store/hooks/useAuth";
import {
  useEffectivePermissions,
} from "../../../store/hooks/useRbac";
import { PERMISSIONS } from "../../../utils/rbac/permissions";

/**
 * GET /v2/exit/my-exit is authorized for MY_EXIT_* only on many backends.
 * Users with only Resignation must not call it (403); they rely on
 * GET /v2/exit/resignation-form and lifecycle GETs instead.
 */
export function useMyExitListQueryGate(): {
  skipMyExit: boolean;
  rbacReady: boolean;
} {
  const { user } = useAuth();
  const sessionReady = Boolean(user?.id);
  const { codes, isReady: rbacReady } = useEffectivePermissions();

  const hasMyExitView = codes.has(PERMISSIONS.MY_EXIT_VIEW);
  const hasMyExitManage = codes.has(PERMISSIONS.MY_EXIT_MANAGE);
  const hasResignationView = codes.has(PERMISSIONS.RESIGNATION_VIEW);
  const hasResignationManage = codes.has(PERMISSIONS.RESIGNATION_MANAGE);

  const skipMyExit =
    !sessionReady ||
    !rbacReady ||
    (!hasMyExitView && !hasMyExitManage && !hasResignationView && !hasResignationManage);

  return { skipMyExit, rbacReady };
}
